import TrustpilotBadge from '@/components/TrustpilotBadge'
import CTAButton from '@/components/shared/CTAButton'

const VehicleHeroSection = ({ vehicleMake, heroImage }) => {
  return (
    <section
      className={`bg-[url('${heroImage}')] relative flex min-h-[70vh] items-center justify-center bg-cover bg-[35%_center] bg-no-repeat md:min-h-[82vh] md:bg-[center_bottom_20%]`}
    >
      <div className="absolute inset-0 bg-black/40"></div>
      <div className="relative z-10 container mx-auto px-4 py-6 text-center md:py-8">
        <h1 className="mb-4 text-center text-4xl font-black tracking-tight text-white uppercase sm:mb-6 sm:text-6xl">
          Claim for Mis-Sold{' '}
          <span className="decoration-primary text-white underline">
            {vehicleMake}
          </span>{' '}
          Car Finance
        </h1>
        <p className="font-raleway-numbers mx-auto mb-6 max-w-xl text-lg leading-relaxed font-bold text-white sm:text-xl md:mb-8 md:max-w-3xl lg:text-2xl">
          Were you mis-sold {vehicleMake} car finance? Millions of drivers are
          potentially owed compensation. Check your eligibility in just 60
          seconds with our {vehicleMake} refund checker.
          <br />
          No win, no fee
          <sup style={{ fontSize: '0.5em', verticalAlign: 'super' }}>3</sup>.
        </p>
        <div className="mb-6 flex justify-center md:mb-8">
          <CTAButton />
        </div>
        <div className="flex justify-center">
          <TrustpilotBadge rating="4star" />
        </div>
      </div>
    </section>
  )
}

export default VehicleHeroSection
